import {
    Box,
    Button,
    TextField,
    FormControl,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Autocomplete from "@mui/material/Autocomplete";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import DatePicker from "react-datepicker";
import "./deletionForm.css";

const DeletionForm = () => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const { auth } = useContext(AuthContext);
    const accessToken = auth.accessToken;

    const [subscribersList, setSubscribersList] = useState([]);

    const [botRequestDate, setBotRequestDate] = useState("");
    const [citReceiveDate, setCitReceiveDate] = useState("");
    const years = range(1930, getYear(new Date()) + 1, 1);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const botDate = new Date(botRequestDate);

    // Extract year, month, and day
    const year = botDate.getFullYear();
    const month = String(botDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
    const day = String(botDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedBotRequestDate = `${year}-${month}-${day}`;

    const citDate = new Date(citReceiveDate);

    // Extract year, month, and day
    const citYear = citDate.getFullYear();
    const citMonth = String(citDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
    const citDay = String(citDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedCitReceiveDate = `${citYear}-${citMonth}-${citDay}`;

    useEffect(() => {
        axios
          .get("/api/subscribers", {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          })
          .then((response) => {
            setSubscribersList(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }, [accessToken]);

    const handleFormSubmit = async (values) => {
        const subject = values.subject;
        const subscriber = values.subscriber;
        const requestFileUpload = values.requestFileUpload;
        try {
            const formData = new FormData();
            formData.append("botRequestDate", formattedBotRequestDate);
            formData.append("citReceiveDate", formattedCitReceiveDate);
            formData.append("subject", subject.toUpperCase());
            formData.append("subscriber", subscriber);
            formData.append("requestFileUpload", requestFileUpload);
            formData.append("requestBy", auth.username);

            await axios.post("/api/add-deletion-request", formData);
            toast.success("Request added successfully!", {
                position: toast.POSITION.TOP_CENTER,
            });
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="app">
            <MyProSidebar />
            <main className="content">
                <Topbar />
                <Box m="20px">
                    <Header title="DELETION REQUEST" subtitle="Create a new deletion request in the system" />

                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={checkoutSchema}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gap="30px"
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Subject"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.subject}
                                        name="subject"
                                        error={!!touched.subject && !!errors.subject}
                                        helperText={touched.subject && errors.subject}
                                        sx={{ gridColumn: "span 2" }}
                                    />
                                    <DatePicker
                                        className="datePicker"
                                        placeholderText="BOT Written Date *"
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                        }) => (
                                            <div
                                                style={{
                                                    margin: 0,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <button
                                                    onClick={decreaseMonth}
                                                    disabled={prevMonthButtonDisabled}
                                                >
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={getYear(date)}
                                                    onChange={({ target: { value } }) =>
                                                        changeYear(value)
                                                    }
                                                >
                                                    {years.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    value={months[getMonth(date)]}
                                                    onChange={({ target: { value } }) =>
                                                        changeMonth(months.indexOf(value))
                                                    }
                                                >
                                                    {months.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <button
                                                    onClick={increaseMonth}
                                                    disabled={nextMonthButtonDisabled}
                                                >
                                                    {">"}
                                                </button>
                                            </div>
                                        )}
                                        selected={botRequestDate}
                                        onChange={(date) => setBotRequestDate(date)}
                                    />

                                    <FormControl
                                        fullWidth
                                        variant="filled"
                                        sx={{ gridColumn: "span 2" }}
                                    >
                                        <Autocomplete
                                            id="subscriber-select"
                                            options={subscribersList}
                                            getOptionLabel={(option) => option.subscriber_name}
                                            value={
                                                subscribersList.find(
                                                    (sub) => sub.subscriber_name === values.subscriber
                                                ) || null
                                            }
                                            onChange={(event, newValue) => {
                                                handleChange({
                                                    target: {
                                                        name: "subscriber",
                                                        value: newValue?.subscriber_name || "",
                                                    },
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="subscriber"
                                                    label="Subscriber"
                                                    error={!!touched.subscriber && !!errors.subscriber}
                                                    helperText={touched.subscriber && errors.subscriber}
                                                />
                                            )}
                                        />
                                    </FormControl>

                                    <DatePicker
                                        className="datePicker"
                                        placeholderText="CIT Received Date *"
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                        }) => (
                                            <div
                                                style={{
                                                    margin: 0,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <button
                                                    onClick={decreaseMonth}
                                                    disabled={prevMonthButtonDisabled}
                                                >
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={getYear(date)}
                                                    onChange={({ target: { value } }) =>
                                                        changeYear(value)
                                                    }
                                                >
                                                    {years.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    value={months[getMonth(date)]}
                                                    onChange={({ target: { value } }) =>
                                                        changeMonth(months.indexOf(value))
                                                    }
                                                >
                                                    {months.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <button
                                                    onClick={increaseMonth}
                                                    disabled={nextMonthButtonDisabled}
                                                >
                                                    {">"}
                                                </button>
                                            </div>
                                        )}
                                        selected={citReceiveDate}
                                        onChange={(date) => setCitReceiveDate(date)}
                                    />
                                    <input
                                        type="file"
                                        name="requestFileUpload"
                                        placeholder="Select a file"
                                        onChange={(event) => {
                                            values.requestFileUpload = event.target.files[0];
                                        }}
                                        className="formInputFile"
                                    />
                                </Box>
                                <Box display="flex" justifyContent="end" mt="20px">
                                    <Button type="submit" color="success" variant="contained">
                                        Submit
                                    </Button>
                                </Box>
                                <ToastContainer />
                            </form>
                        )}
                    </Formik>
                </Box>
            </main>
        </div>
    );
};

const checkoutSchema = yup.object().shape({
    subject: yup.string().required("required"),
    subscriber: yup.string().required("required"),
    requestFileUpload: yup.string().required("required"),
});
const initialValues = {
    subject: "",
    subscriber: "",
    requestFileUpload: "",
};

export default DeletionForm;